import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import './PublicSimplePages.css';

const LegalPage = () => {
  const { t } = useTranslation();
  return (
    <div className="public-simple-page">
      <Helmet>
        <title>{`${t('public.legal.metaTitle')} | ${t('public.brand.titleSuffix')}`}</title>
      </Helmet>
      <Navbar />
      <main className="public-simple-page__main">
        <h1>{t('public.legal.title')}</h1>
        <div className="public-simple-card public-legal-card">
          <h2>{t('public.legal.associationTitle')}</h2>
          <p>{t('public.legal.associationBody')}</p>
          <h2>{t('public.legal.siteTitle')}</h2>
          <p>{t('public.legal.siteBody')}</p>
          <h2>{t('public.legal.donationsTitle')}</h2>
          <p>{t('public.legal.donationsBody')}</p>
          <h2>{t('public.legal.privacyTitle')}</h2>
          <p>{t('public.legal.privacyBody')}</p>
          <h2>{t('public.legal.contactTitle')}</h2>
          <p>{t('public.legal.contactBody')}</p>
        </div>
      </main>
    </div>
  );
};

export default LegalPage;
